/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large headings only need 3:1 to pass AA.`)
};

const es_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los titulares grandes solo necesitan 3:1 para aprobar AA.`)
};

const de_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Große Überschriften benötigen nur 3:1, um AA zu bestehen.`)
};

const nl_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grote koppen hebben maar 3:1 nodig om aan AA te voldoen.`)
};

const fr_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les grands titres n'ont besoin que de 3:1 pour réussir le niveau AA.`)
};

const it_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I titoli grandi hanno bisogno solo di 3:1 per superare l'AA.`)
};

const pt_br2_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Títulos grandes só precisam de 3:1 para passar no AA.`)
};

const pt_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os títulos grandes só precisam de 3:1 para passar no AA.`)
};

const ja_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きい見出しはAA合格に3:1あれば十分です。`)
};

const zh_cc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大号标题只需达到 3:1 即可通过 AA 标准。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_ex3", locale)
	if (locale === "en") return en_cc_ex3(inputs)
	if (locale === "es") return es_cc_ex3(inputs)
	if (locale === "de") return de_cc_ex3(inputs)
	if (locale === "nl") return nl_cc_ex3(inputs)
	if (locale === "fr") return fr_cc_ex3(inputs)
	if (locale === "it") return it_cc_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_cc_ex3(inputs)
	if (locale === "pt") return pt_cc_ex3(inputs)
	if (locale === "ja") return ja_cc_ex3(inputs)
	return zh_cc_ex3(inputs)
};